<template>
  <div class="page pda-screen ignore">
    <header-title
      title="Tag Registration"
      @onRefresh="init"
      has-refresh
    ></header-title>
    <div class="page-body">
      <!-- <div class="input-box iconfont icon-saoma">
        <input
          allowClear
          :readonly="isMobile"
          v-model="scanValue"
          @keypress.enter="scanKeyEnter(scanValue)"
        />
      </div> -->

      <div class="info-box">
        <van-form
          label-width="40%"
          input-align="right"
          ref="formRef"
          error-message-align="right"
        >
          <van-cell-group>
            <van-field
              label="Tag Id"
              label-width="30%"
              label-class="vip-label"
              v-model="form.tagId"
              :readonly="!isManual"
              :placeholder="
                isManual ? 'Please enter Tag Id' : 'Please scan Tag Id'
              "
              name="tagId"
              required
              :rules="[{ required: true, message: 'Tag Id are required' }]"
            >
              <template #button>
                <van-button
                  size="small"
                  @click="isManual = !isManual"
                  :icon="isManual ? 'edit' : 'scan'"
                ></van-button>
              </template>
            </van-field>
            <van-field
              label="Tag Type"
              v-model="form.tagType"
              placeholder="Please select"
              name="tagType"
              @click="onClickPicker('tagTypes')"
              readonly
            />
            <van-field
              label="Registration Type"
              v-model="form.registrationType"
              placeholder="Please select"
              @click="onClickPicker('registrationTypes')"
              required
              name="registrationType"
              :rules="[
                { required: true, message: 'Registration Type are required' },
              ]"
              readonly
            />
            <van-field
              v-if="form.registrationType === 'LC'"
              label="FIFO Line"
              v-model="form.fifoLine"
              placeholder="Please select"
              name="fifoLine"
              @click="onClickPicker('fifoLines')"
              readonly
            />
            <van-field
              v-if="form.registrationType === 'LC' && form.fifoLine"
              label="Object Id"
              v-model="form.objectId"
              placeholder="Please select"
              @click="onClickPicker('objectIds')"
              name="objectId"
              readonly
            />
            <van-field
              v-if="form.registrationType === 'LC'"
              label="Kanban Group"
              v-model="form.kanbanGroup"
              placeholder="Please select"
              @click="onClickPicker('kanbanGroups')"
              readonly
              required
              name="kanbanGroup"
              :rules="[
                { required: true, message: 'Kanban Group are required' },
              ]"
            />
            <van-field
              v-if="form.registrationType === 'KIT'"
              label="Net Group"
              v-model="form.netGroup"
              placeholder="Please select"
              @click="onClickPicker('netGroups')"
              readonly
              required
              name="netGroup"
              :rules="[{ required: true, message: 'Net Group are required' }]"
            />
            <van-field
              v-if="form.registrationType === 'KIT'"
              label="Cart Id"
              v-model="form.cartId"
              placeholder="Please input..."
              required
              name="cartId"
              :rules="[{ required: true, message: 'Cart Id are required' }]"
            />
          </van-cell-group>
        </van-form>
      </div>
    </div>
    <div class="page-footer">
      <a-button type="primary" @click="registration">Registration</a-button>
      <a-button @click="clearForm">Cancel</a-button>
    </div>
    <van-popup v-model:show="showPicker" position="bottom">
      <van-picker
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>
<script setup>
  import HeaderTitle from '@/layout/header-title'
  import { trimAll } from '@/utils'
  import { ref, reactive } from 'vue'

  import {
    Form as VanForm,
    Field as VanField,
    CellGroup as VanCellGroup,
    Popup as VanPopup,
    picker as VanPicker,
    button as VanButton,
    Notify,
  } from 'vant'
  import request from '@/utils/request'

  const form = reactive({
    tagType: null,
    registrationType: null,
    fifoLine: null,
    objectId: null,
    kanbanGroup: null,
    netGroup: null,
    tagId: '',
    cartId: null,
  })

  // 下拉框相关---------------------------------------------------
  const showPicker = ref(false)
  const columns = ref([])
  const selectList = reactive({
    tagTypes: ['UWB', 'RFID'],
    registrationTypes: [
      { value: 'LC', text: 'LC' },
      { value: 'KIT', text: 'Kitting Cart' },
    ],
    fifoLines: [],
    objectIds: [],
    kanbanGroups: [],
    netGroups: [],
  })
  const _getFifoLines = () => {
    request({
      url: '/api/uwb/findFifoRegions',
      method: 'get',
    }).then((res) => {
      selectList.fifoLines = res.body
    })
  }
  const _getKanbanGroups = () => {
    request({
      url: '/api/uwb/findKanbanGroups',
      method: 'get',
    }).then((res) => {
      selectList.kanbanGroups = res.body
    })
  }
  const _getObjectIds = (regionCode) => {
    request({
      url: '/api/uwb/findObjectIds',
      method: 'get',
      params: { regionCode },
    }).then((res) => {
      selectList.objectIds = res.body
    })
  }
  const _getNetGroups = () => {
    request({
      url: '/api/uwb/findNetGroups',
      method: 'get',
    }).then((res) => {
      selectList.netGroups = res.body
    })
  }
  const init = () => {
    _getNetGroups()
    _getKanbanGroups()
    _getFifoLines()
  }
  init()

  const currentSelectType = ref('')
  const onClickPicker = (type) => {
    columns.value = selectList[type]
    currentSelectType.value = type.slice(0, -1)
    showPicker.value = true
  }

  const onConfirm = (value) => {
    if (typeof value === 'object') {
      form[currentSelectType.value] = value.value
    } else {
      form[currentSelectType.value] = value
    }
    if (currentSelectType.value === 'fifoLine') {
      _getObjectIds(value)
    }
    if (currentSelectType.value === 'registrationType') {
      if (value === 'LC') {
        form.netGroup = null
        form.cartId = null
      } else {
        form.kanbanGroup = null
        form.fifoLine = null
        form.objectId = null
      }
    }
    showPicker.value = false
  }
  // end ---------------------------------------------------

  // tagId 扫描---------------------------------------------------

  const isManual = ref(false)

  // 监听扫码输入
  const watchScanInput = () => {
    var keyStr = ''
    var lastTime = null
    var nextTime = null
    var lastCode = null

    document.onkeydown = function (e) {
      //获取当前时间
      nextTime = new Date().getTime()
      if (e.key == 'Enter' || e.key === 'F8') {
        //回车字符
        if (keyStr != '' && nextTime - lastTime <= 30) {
          form.tagId = trimAll(keyStr, 'g') // mht
          keyStr = ''
          lastCode = null
          lastTime = null
        }
      } else if (e.key.length === 1) {
        if (lastCode == null && lastTime == null) {
          //初始字母
          keyStr = e.key
        } else if (
          lastCode != null &&
          lastTime != null &&
          nextTime - lastTime <= 30
        ) {
          keyStr += e.key
        } else {
          //手动输入
          keyStr = ''
          lastCode = null
          lastTime = null
        }
        lastCode = e.key
        lastTime = nextTime
      }
    }
  }
  watchScanInput()
  // end ---------------------------------------------------

  // cancel
  const clearForm = () => {
    Object.keys(form).forEach((item) => {
      form[item] = ''
    })
    formRef.value.resetValidation()
  }

  // registration
  const formRef = ref(null)
  const registration = () => {
    formRef.value.validate().then(() => {
      if (form.registrationType === 'LC') {
        request({
          url: '/api/uwb/registerLC',
          method: 'post',
          nonstandard: true,
          data: form,
        }).then((res) => {
          if (res.errCode === '0000') {
            Notify({ type: 'success', message: 'Success' })
            clearForm()
          } else {
            Notify({
              type: 'warning',
              message: res.errMsg.replace(/<br>/g, '\n'),
            })
          }
        })
      } else {
        request({
          url: '/api/uwb/registerKittingCart',
          method: 'post',
          nonstandard: true,
          data: form,
        }).then((res) => {
          if (res.errCode === '0000') {
            Notify({ type: 'success', message: 'Success' })
            clearForm()
          } else {
            Notify({
              type: 'warning',
              message: res.errMsg.replace(/<br>/g, '\n'),
            })
          }
        })
      }
    })
  }
</script>
<style lang="less" scoped>
  @import 'scan.less';
</style>
